// geophysics-research-init.js — wires the Geophysics Validation tab.
// Mirrors materials-research-init.js: lazy-load on first tab open,
// auto-rerun on subsequent opens, Run All button shortcut.

import {
  initGeophysicsResearch,
  renderGeophysicsValidationTable,
  runMogi, runOkada, runPrem, runGr
} from './geophysics-research.js';

async function bootstrap() {
  await initGeophysicsResearch();

  const validationTab = document.querySelector('.geotab[data-geo="validation"]');
  if (validationTab) {
    let loaded = false;
    validationTab.addEventListener('click', async () => {
      if (!loaded) {
        await renderGeophysicsValidationTable();
        loaded = true;
      } else {
        window.gdbsRerunAllGeophysicsValidation?.();
      }
    });
  }

  const runBtn = document.getElementById('btn-geo-validation-run');
  if (runBtn) {
    runBtn.addEventListener('click', async () => {
      const tbody = document.getElementById('tbody-geo-validation');
      if (tbody && !tbody.children.length) {
        await renderGeophysicsValidationTable();
      } else {
        window.gdbsRerunAllGeophysicsValidation?.();
      }
    });
  }
  // New research-grade engines.
  document.getElementById('btn-mogi-run')?.addEventListener('click', runMogi);
  document.getElementById('btn-okada-run')?.addEventListener('click', runOkada);
  document.getElementById('btn-prem-run')?.addEventListener('click', runPrem);
  document.getElementById('btn-gr-run')?.addEventListener('click', runGr);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
